import ScanReader from "./ScanReader";
export default ScanReader;
